/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var objectEntries = Object.entries || function (obj) {
  return Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });
};

export default objectEntries;



//////////////////
// WEBPACK FOOTER
// ./~/graphql/polyfills/objectEntries.mjs
// module id = 6UJp
// module chunks = 9